export default [
    {
        path: "proveedores",
        name: "proveedores",
        component: () => import(/* webpackChunkName: "gestionProveedores" */ "./proveedores.vue"),
    }
]